import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { useMedia } from 'react-media-match';
import Notification from '@empiriecom/module-components/Notification';
import { Attribute } from '@/src/interfaces';

const SizeHintWrapper = styled.div<{ mobile: boolean }>`
  ${({ mobile }) => mobile && 'margin: 0 0.75rem 1.5rem;'};
`;

export type SizeHintProps = Pick<Attribute, 'values'>;

/**
 * This is the size hint component. If the current product has a size hint available this
 * component renders the size hint component with the according message.
 */
export const SizeHint: FunctionComponent<SizeHintProps> = ({ values }): ReactElement => {
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  return values !== null ? (
    <SizeHintWrapper mobile={isMobile} data-testid="size-hint">
      <Notification level="info" isInline isAnimated={false} content={values.join('')} />
    </SizeHintWrapper>
  ) : null;
};

export default SizeHint;
